<template>
    <div class="course-live-online-study-container ">
        <page-background />
        <div class="box" :style="isMobile?{width:'100%'}:{}">
            <div v-if="!isMobile" class="course-detail-route">
                <a-breadcrumb>
                    <a-breadcrumb-item href="">
                        <router-link to="/">
                            <a-icon type="home" />
                            首页
                        </router-link>
                    </a-breadcrumb-item>
                    <a-breadcrumb-item href="">
                        <span>视频详情</span>
                    </a-breadcrumb-item>
                </a-breadcrumb>
            </div>

            <div class="clear-float">
                <course-play />
            </div>

            <course-info-tab is-course-play class="course-info-tab"
                             v-if="!(isMobile && selectedSection.liveStatus !== '2')" />
        </div>
    </div>

</template>

<script>
    import common from "../../mixin/common";
    import CoursePlay from "@views/live-online/components/CoursePlay";
    import {DISPATCH_LIVE_ONLINE_SWITCH_SECTION} from "@constants/action-type/course-live-online-action-type"
    import {DISPATH_LIVE_ONLINE_COURSE_INFO} from "@constants/action-type/course-live-online-action-type";
    import CourseInfoTab from "@views/live-online/components/CourseInfoTab";
    import {createNamespacedHelpers} from "vuex";

    const {mapState} = createNamespacedHelpers('courseLiveOnline');

    export default {
        mixins: [common],
        name: "CourseLiveOnlineStudy",
        components: {
            CoursePlay,
            CourseInfoTab
        },
        mounted() {
            this.$store.dispatch(DISPATH_LIVE_ONLINE_COURSE_INFO, {courseId: this.$route.params.courseId}).then(() => {
                // 直播课程加载完
                // 判断是否有sectionId属性，如果有就切换到指定章节，否则切换到下个直播的章节
                if (this.$route.query.sectionId) {
                    this.$store.dispatch(DISPATCH_LIVE_ONLINE_SWITCH_SECTION, {sectionId: this.$route.query.sectionId});
                } else {
                    this.$store.dispatch(DISPATCH_LIVE_ONLINE_SWITCH_SECTION, {sectionId: this.nextLiveSectionId});
                }
            });
        },
        computed: {
            ...mapState({
                selectedSection: 'selectedSection',
                nextLiveSectionId: "nextLiveSectionId"
            }),
        },
        watch: {
            selectedSection() {
                this.$router.push({
                    query: {sectionId: this.selectedSection.sectionId || ''}
                }).catch(() => {
                });
            }
        }
    }
</script>

<style scoped lang="less">
    .course-live-online-study-container {
        padding-bottom: 40px;
    }

    // 课程详情页头
    .course-detail-route {
        font-size: 16px;
        padding: 10px 0 15px;
    }

    .course-info-tab {
        margin-top: 20px;
        border-radius: 3px;
    }

    /deep/ .active-section {
        color: #00CF8C;
    }

    /deep/ .ant-breadcrumb-link {
        font-size: 16px;
    }

</style>

